export default "__VITE_ASSET__D4HPDxq6__"